
import { TextShow } from 'Utils/Helpers/TextShow';
import { useSelector } from 'react-redux';
import Box from '../Box';
import DeleteType from './delete';
import EditType from './edit';

export default function ListTypes() {
  const { total, appointmentTypes } = useSelector((state) => ({
    total: state.staff.total,
    appointmentTypes: state.setting.appointmentTypes,
  }));
  return (
    <Box
      title={"نوع‌های ثبت شده"}
      body={
        (appointmentTypes && appointmentTypes.length !== 0)
        ? <>
          {
            appointmentTypes.map(items => {
              return(
                <div className='box-types'>
                  <div className='flex-column-center-start'>
                    <TextShow
                      title={"عنوان :"}
                      data={<span style={{color: items.color}}>{items.name}</span>}
                      className={'no-hide text-muted'}
                    />
                    <div>
                      <small className='ms-1'>
                        {items.staffs.length === 1 ? 'پزشک : ' : 'پزشکان : '}
                      </small>
                      {
                        items.staffs.map(id => {
                          return (
                            <small className='each-status'>
                              {total.find(i => i.id === id).name}
                            </small>
                          )
                        })
                      }
                    </div>
                  </div>
                  <div className='actions'>
                    <EditType
                      id={items.id}
                      title={items.name}
                      staffs={items.staffs}
                      color={items.color}
                    />
                    <DeleteType
                      id={items.id}
                      title={items.name}
                      staffs={items.staffs}
                    />
                  </div>
                </div>
              )
            })
          }
        </> : <div className='w-100 text-center pb-2'>
          <small>{"نوعی ثبت نشده"}</small>
        </div>
      }
    />
  );
}